import VelIcon from './icon'
import VelBtn from './button'
import VelLink from './link'
import VelRadio from './radio'
import VelTable from './table'
import VelTips from './tips'
import VelPopover from './popover'
import VelTag from './tag'
import VelLine from './line'
import VelTimeLine from './timeline'
import VelCollapse from './collapse'
import VelCard from './card'
import VelSetps from './steps'
import VelDropdown from './dropdown'
import VelPageHeader from './pageheader'
import VelBreadcrumb from './breadcrumb'
import VelTabs from './tabs'
import VelAlert from './alert'
import VelDes from './des'
import VelSkeleton from './skeleton'
import VelSkeletonItem from './skeletonitem'
import VelAvatar from './avatar'
import VelBadge from './badge'
import VelPagination from './pagination'
import VelTree from './tree'
import VelProgress from './progress'
import VelTransfe from './transfer'
import VelDateTime from './datetime'
import VelSlider from './slider'
import VelSwitch from './switch'
import VelCascader from './cascader'
import VelSelect from './select'
import VelInputNum from './inputnum'
import VelInput from './input'
import VelCheckbox from './checkbox'
import VelModal from './modal'

const components = [
    VelIcon,
    VelBtn,
    VelLink,
    VelRadio,
    VelTable,
    VelCard,
    VelCollapse,
    VelLine,
    VelPopover,
    VelTag,
    VelTips,
    VelTimeLine,
    VelSetps,
    VelDropdown,
    VelPageHeader,
    VelBreadcrumb,
    VelTabs,
    VelAlert,
    VelDes,
    VelSkeleton,
    VelSkeletonItem,
    VelAvatar,
    VelBadge,
    VelPagination,
    VelTree,
    VelProgress,
    VelTransfe,
    VelDateTime,
    VelSlider,
    VelSwitch,
    VelCascader,
    VelSelect,
    VelInputNum,
    VelInput,
    VelCheckbox,
    VelModal,
]

const install = function (Vue) {
    components.forEach(component =>{
        Vue.component(component.name, component)
    })
}

if(typeof window !== 'undefined' && window.Vue){
    install(window.Vue)
}

export default {
    install,
    VelIcon,
    VelBtn,
    VelLink,
    VelRadio,
    VelTable,
    VelCard,
    VelCollapse,
    VelLine,
    VelPopover,
    VelTag,
    VelTips,
    VelTimeLine,
    VelSetps,
    VelDropdown,
    VelPageHeader,
    VelBreadcrumb,
    VelTabs,
    VelAlert,
    VelDes,
    VelSkeleton,
    VelSkeletonItem,
    VelAvatar,
    VelBadge,
    VelPagination,
    VelTree,
    VelProgress,
    VelTransfe,
    VelDateTime,
    VelSlider,
    VelSwitch,
    VelCascader,
    VelSelect,
    VelInputNum,
    VelInput,
    VelCheckbox,
    VelModal,
}